module.exports = "<a aria-controls=\"adpHelpButton.html\" href=\"javascript:;\" ng-class=\"[{grey: $ctrl.isGrey, blue: $ctrl.isBlue}, {attachment: $ctrl.hasAttachment}]\">\n    <span class=\"icon {{$ctrl.icon}}\" ng-if=\"$ctrl.isGrey\"></span>\n    <i class=\"ico material-icons\" ng-if=\"$ctrl.isBlue\">{{$ctrl.icon}}</i>\n    <span class=\"icon-btn-text\">{{$ctrl.label}}</span>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpIconButton/adpIconButton.html
// module id = 555
// module chunks = 0